/*eslint-disable*/
import {
  Card,
  CardContent,
  FormControl,
  Grid,
  Typography
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import _ from "lodash";
import React from "react";
import { Field } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading.jsx";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import assumptions from "./objects/assumptions"

import { required, percentage } from "helpers/ValidationHelpers";

const grandSeperator = val => {
  
  val = val.toLocaleString().replace(/,/g, "").replace(/ /g, "");
  let parsed = parseFloat(val);

  if (!isNaN(parsed)) {
    return parsed.toLocaleString().replace(/,/g, " ");
  } else {
    return val;
  }
};

class Assumptions extends React.Component {
  componentDidMount() {
    this.props.scrollMeBar();
  }
  
  checkItem = (label, name) => {
    return (
      <React.Fragment>
        <Grid item xs={12} sm={12} md={12}>
          <Grid container>
            <GridItem
              xs={12}
              sm={12}
              md={6}
              style={{ marginBottom: "30px", position: "relative" }}
            >
              <Typography
                variant="body1"
                style={{
                  position: "absolute",
                  top: "25%"
                }}
              >
                {label}
              </Typography>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} style={{ marginBottom: "30px" }}>
              <FormControl>
                <Field
                  component={FormCheckbox}
                  name={name}
                  onChange={() => {
                    this.forceUpdate();
                  }}
                />
              </FormControl>
            </GridItem>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    let { checkValidation } = this.props;
    var clientD = "";

    if(this.props.state)
      if(this.props.state.client)
        clientD = this.props.state.client.first_name + " " + this.props.state.client.surname
    

    return (
      <div className="contentWithStepper">
        <Card>
          <CardContent>
            <CustomCardHeading
              subheading={"Financial Needs Analysis"}
              caption={clientD}
              headline={"Fixed Assumptions"}
            />
            <Grid container>
              <Grid item xs={12} sm={12} md={10} style={{ margin: "0px auto" }}>
                <Grid container>
                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                      Estate Duty Exemption:
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px", textAlign: "left" }}
                  >
                    <Typography variant="body1">
                      R {grandSeperator(assumptions.estate_duty_exemption)}
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                      Primary Residence Exemption:
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      R{" "}
                      {grandSeperator(assumptions.primary_residence_exemption)}
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                      Small Business Exemption:
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      R {grandSeperator(assumptions.small_business_exemption)}
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                      Inclusion Rate for CGT:
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      {assumptions.inclusion_rate_for_cgt}%
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">Masters Fees:</Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      R {grandSeperator(assumptions.masters_fees)}
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">Transfer costs:</Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      {assumptions.transfer_costs}%
                    </Typography>
                  </GridItem>

                  

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                    Rate of Estate Duty (&#60;R30m):
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      {assumptions.estateDutyLT}%
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                    Rate of Estate Duty (&#62;R30m):
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      {assumptions.estateDutyGT}%
                    </Typography>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Typography variant="body1">
                    CGT Exclusion on Death: 
                    </Typography>
                  </GridItem>
                  <GridItem
                    xs={12}
                    sm={12}
                    md={6}
                    style={{ marginBottom: "30px" }}
                  >
                    <Typography variant="body1">
                      R {grandSeperator(assumptions.cgtExclusionAtDeath)}
                    </Typography>
                  </GridItem>

                 
                  
                  

                  
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

export default Assumptions;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/Assumptions.jsx